import { render, staticRenderFns } from "./TracksReleasesEditPanelTopSlot.vue?vue&type=template&id=31ff1290"
import script from "./TracksReleasesEditPanelTopSlot.vue?vue&type=script&lang=js"
export * from "./TracksReleasesEditPanelTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports